import styled from '@emotion/styled';
import type { StylesConfig } from 'react-select';

import { FrontSelect } from '../../../../../ui-components';
import { chartColors } from '../helpers/conts';
import type { chartMetricType, OptionType } from '../helpers/types';
import { useBrandPerformanceChartStore } from '../store/store';

interface IProps {
  chartMetricType: chartMetricType;
}

const dot = (color = 'transparent') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 8,
    height: 10,
    width: 10,
  },
});

export const ChartMetricFilter = ({ chartMetricType }: IProps) => {
  const { [chartMetricType]: value, setMetric, getOptions } = useBrandPerformanceChartStore();

  const colourStyles: StylesConfig<OptionType> = {
    input: (styles) => ({ ...styles, ...dot() }),
    placeholder: (styles) => ({ ...styles, ...dot('#ccc') }),
    singleValue: (styles) => ({ ...styles, ...dot(chartColors[chartMetricType]) }),
  };

  return (
    <Wrapper>
      <FrontSelect
        width="200px"
        placeholder="Select Metric"
        value={value}
        options={getOptions(chartMetricType)}
        onChange={(option) => option && setMetric(option as OptionType, chartMetricType)}
        isMulti={false}
        isSearchable={false}
        isLoading={false}
        noOptionsMessage={() => 'No Metrics Available'}
        styles={colourStyles}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
